import React from "react";

const ServiceCard = ({
  icon,
  title,
  subtitle,
  animationPath,
  frontColor,
  backColor,
}) => {
  return (
    <div
      className="card-container"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <div className="homeCard-container" style={{ perspective: "1000px" }}>
        <div
          // className="homeCard"
          style={{
            position: "relative",
            width: "300px",
            height: "200px",
            // transformStyle: "preserve-3d",
            // transition: "transform 0.6s ease-in-out",
          }}
        >
          {/* Front Side */}
          <div
            className="front"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              background:
                frontColor || "linear-gradient(135deg, #4A90E2, #50E3C2)", // default gradient
              color: "#fff",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              backfaceVisibility: "hidden",
            }}
          >
            {/* <i className={`fa fa-${icon}`} style={{ fontSize: "36px" }}></i> */}
            <h2 className="text-2xl font-bold">{title}</h2>
            <p
              style={{
                fontSize: 16,
                fontWeight: "bold",
                margin: 20,
                textAlign: "center",
              }}
            >
              {subtitle}
            </p>
          </div>
          {/* Back Side */}
          {/* <div
            className="back"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              background:
                backColor || "linear-gradient(135deg, #FF7E5F, #FEB47B)", // default gradient
              color: "#fff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "10px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
              transform: "rotateY(180deg)",
              backfaceVisibility: "hidden",
            }}
          >
            <LottieView
              animationData={animationPath}
              loop
              autoplay
              style={{ width: "80%", height: "80%" }}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
